import { render, staticRenderFns } from "./silder.vue?vue&type=template&id=8677c170&"
import script from "./silder.vue?vue&type=script&lang=js&"
export * from "./silder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "silder.vue"
export default component.exports